import { Card, CardContent, CardHeader, CardTitle, InfoTooltip, Skeleton } from '@client/toolkit';
import { FaRegCircleQuestion } from 'react-icons/fa6';
import classNames from 'classnames';
import { Link, useLocation } from 'react-router-dom';

interface DashboardCardWrapperProps {
  to?: string;
  icon?: React.ReactNode;
  title: string;
  loading?: boolean;
  tooltip?: string;
  titleRightContent?: React.ReactNode;
  className?: string;
  children: React.ReactNode;
  contentClassName?: string;
}

export const DashboardCardWrapper = ({
  to = '',
  icon,
  title,
  tooltip,
  loading = false,
  titleRightContent,
  className,
  children,
  contentClassName,
}: DashboardCardWrapperProps) => {
  const { search } = useLocation();
  const cardContentClassName = classNames(contentClassName);
  return (
    <Link className="flex flex-row" to={to + search}>
      <Card className={classNames(className, 'w-full')} data-testid="dashboard-card" overflowX={false}>
        <CardHeader>
          <CardTitle variant="default" className="flex items-center gap-2 justify-between">
            <div className="flex items-center gap-2">
              {icon && (
                <span className="flex mr-1" data-testid="card-icon">
                  {icon}
                </span>
              )}
              <span data-testid="card-title">{title}</span>
              {tooltip && (
                <InfoTooltip message={tooltip} messageClassName="w-40 z-50" enterDelay="delay-100">
                  <FaRegCircleQuestion className="text-gray-400 text-sm" data-testid="card-tooltip" />
                </InfoTooltip>
              )}
            </div>
            {titleRightContent && <div data-testid="card-title-right">{titleRightContent}</div>}
          </CardTitle>
        </CardHeader>
        <CardContent data-testid="card-content" className={cardContentClassName}>
          {loading ? <Skeleton className="w-[100%] min-h-[250px]" /> : children}
        </CardContent>
      </Card>
    </Link>
  );
};
